import React, { useState } from 'react'

import { Box, Flex, Input } from '@chakra-ui/react'
import { Typography } from '@pnld/components-web'

const DateRangeFilter = ({
  onStartDateChange,
  onFinalDateChange,
}: {
  onStartDateChange: (date: string) => void
  onFinalDateChange: (date: string) => void
}) => {
  const [startDate, setStartDate] = useState('')
  const [finalDate, setFinalDate] = useState('')
  const [error, setError] = useState('')

  const parseDate = (value: string): Date | null => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null
    const date = new Date(value)
    return isNaN(date.getTime()) ? null : date
  }

  const validateDates = (start: string, end: string) => {
    if (!start || !end) {
      setError('')
      return true
    }

    const startDate = parseDate(start)
    const finalDate = parseDate(end)

    if (!startDate || !finalDate) {
      setError('Data inválida')
      return false
    }

    if (finalDate < startDate) {
      setError('Data final não pode ser menor que a data inicial')
      return false
    }

    if (finalDate.getTime() - startDate.getTime() > 1000 * 60 * 60 * 24 * 31) {
      setError('Intervalo de datas não pode ser maior que 31 dias')
      return false
    }

    setError('')
    return true
  }

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newStartDate = e.target.value
    setStartDate(newStartDate)

    if (validateDates(newStartDate, finalDate)) {
      onStartDateChange(newStartDate)
    }
  }

  const handleFinalDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFinalDate = e.target.value
    setFinalDate(newFinalDate)

    if (validateDates(startDate, newFinalDate)) {
      onFinalDateChange(newFinalDate)
    }
  }

  return (
    <Box w="full">
      <Flex align="center" gap={2} w="full">
        <Typography variant="b-sm" whiteSpace="nowrap">
          De
        </Typography>
        <Input
          flex={1}
          type="date"
          value={startDate}
          onChange={handleStartDateChange}
          max={finalDate || undefined}
        />
        <Typography variant="b-sm" whiteSpace="nowrap">
          até
        </Typography>
        <Input
          flex={1}
          type="date"
          value={finalDate}
          onChange={handleFinalDateChange}
          min={startDate || undefined}
        />
      </Flex>
      {error && (
        <Typography variant="b-sm" color="red.500" mt={2}>
          {error}
        </Typography>
      )}
    </Box>
  )
}

export default DateRangeFilter
